import React from 'react';
import { components } from 'react-select';
import styles from './CustomOption.module.scss'

const CustomOption = (props: any) => {
  const { data, selectProps } = props;
  console.log('data', data)
  return (
    <components.Option {...props}>
      <div className={styles.customOption}>
        <div className={styles.optionLabel}>{data.label}</div>
        {data.description && (
          <div className={styles.optionDescription}>
            {data.description}
          </div>
        )}
      </div>
    </components.Option>
  );
};

export default CustomOption;